module.exports = __webpack_public_path__ + "img/28-3.9c9d7b9b.jpg";